import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * @param {object} props
 * @param {boolean} props.open
 * @param {(open: boolean) => void} props.onOpenChange
 * @param {boolean} props.success
 * @param {string} props.title
 * @param {string} props.description
 * @param {string} [props.sourceName]
 * @param {string} [props.targetName]
 */
export function MergeResultDialog({ open, onOpenChange, success, title, description, sourceName, targetName }) {
  const hasFormattedSuccessNames = success && String(sourceName || "").trim() && String(targetName || "").trim();
  const hasSingleSuccessName = success && String(sourceName || "").trim() && !String(targetName || "").trim();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title || (success ? "Merge completed" : "Merge failed")}</DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-2 text-sm text-muted-foreground">
              {hasFormattedSuccessNames ? (
                <p>
                  Merged <strong className="font-semibold text-foreground">{sourceName}</strong> into{" "}
                  <strong className="font-semibold text-foreground">{targetName}</strong>.
                </p>
              ) : null}
              {hasSingleSuccessName ? (
                <p>
                  Confirmed <strong className="font-semibold text-foreground">{sourceName}</strong> as the correct patient.
                </p>
              ) : null}
              <p>{description || "No additional details available."}</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={() => onOpenChange(false)}>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
